import { put, take } from "redux-saga/effects";
import { store } from "../../store";
import {
  requestAuctions,
  REQUEST_AUCTIONS_SUCCESS
} from "../../actions/auctions";
import { setAuction } from "../../actions/controllers/auction";

export function* fetchAuctions(locale) {
  // Fetch auctions
  yield put(requestAuctions(locale));
  yield take(REQUEST_AUCTIONS_SUCCESS);
  let state = store.getState();

  // Select auction
  let auction = null;

  let match = false;
  if (state.auction && state.auction.data) {
    for (let item in state.auctions.data) {
      if (state.auction.data === state.auctions.data[item].id) {
        match = true;
        break;
      }
    }
  }

  if (!match && state.auctions && state.auctions.data) {
    for (let item in state.auctions.data) {
      if (auction === null && state.auctions.data[item].id) {
        auction = state.auctions.data[item].id;
      }
      if (state.auctions.data[item].active) {
        auction = state.auctions.data[item].id;
      }
    }
  }

  if (auction) {
    yield put(setAuction(auction));
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/fetchAuctions.js